function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.793 3.207l.707.707L16.586 8 11 13.586 5.414 8 11 2.414l.793.793z",
  stroke: "#E4922F",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.154 13.985c0 .734-.56 1.265-1.154 1.265-.594 0-1.155-.53-1.155-1.265 0-.116.064-.386.24-.81.164-.395.388-.838.62-1.261.1-.182.2-.358.295-.522.095.164.195.34.294.522.232.423.456.866.62 1.26.176.425.24.695.24.81z",
  fill: "#E4922F",
  stroke: "#E4922F",
  strokeWidth: 1.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.381 8.5L11 12.35l4.619-3.85H6.381z",
  fill: "#E4922F",
  stroke: "#E4922F"
});

const SvgFillin = props => React.createElement("svg", _extends({
  viewBox: "0 0 19 17",
  fill: "none"
}, props), _ref, _ref2, _ref3);

export default SvgFillin;